import { DownOutlined, FilterFilled, PlusOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DESC, ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import React, { useEffect, useState } from 'react';
import { getPaginationState } from 'react-jhipster';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Checkbox, Col, DatePicker, Dropdown, Input, Menu, Row, Select, Tooltip } from 'antd';
import Title from 'antd/es/typography/Title';
import { getOnlyOrgView as getEmployees, getSelectBoxWorkPriorityLevel, getSelectBoxWorkStatusActivities } from 'app/entities/common/common.reducer';
import { setFilterActivities, setFilterOrgCheckIn } from 'app/entities/filters/filters.reducer';
import { getAllReportSchedule } from 'app/entities/report-schedule/report-schedule.reducer';
import ModalConfirmComponent from 'app/shared/component/modal/confirm';
import TableComponent from 'app/shared/component/table/table';
import { OrderByType } from 'app/shared/model/enum/order-type.enum';
import { filterOption } from 'app/shared/util/select-filter';
import * as _ from 'lodash';
import { ReactSVG } from 'react-svg';
import { deleteEntity, exportExcel, getEntities } from '../activities.reducer';
import ActivitiesUpdate from '../form/activities-update';
import ReportActivities from '../form/report/form/reportActivities';
import ReportActivitiesResult from '../form/report/view/reportActivitiesResult';
import { columns } from './config';
import FilterModal from './filter/filter';
import { APP_LOCAL_DATE_FORMAT, APP_LOCAL_DATE_FORMAT_PAYLOAD } from 'app/config/constants';
import dayjs from 'dayjs';
import { saveAs } from 'file-saver';
import { getCurrentCheckInType } from 'app/entities/checkIn/checkIn.reducer';
import ConfirmCompleteQuarter from './modal/confirm-complete-quarter';
import ConfirmComplete from './modal/confirm-complete';
import { ConfirmComplete as ConfirmCompleteHalfMonth } from './modal/haft-month/confirm-complete';
import { ConfirmComplete as ConfirmCompleteMonth } from './modal/month/confirm-complete';

const { RangePicker } = DatePicker;
const { Search } = Input;

export const Activities = () => {
  const dispatch = useAppDispatch();
  const pageLocation = useLocation();
  const navigate = useNavigate();
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'lastModifiedDate', DESC), pageLocation.search),
  );

  const activitiesList = useAppSelector(state => state.activities.entities);
  const isLoading = useAppSelector(state => state.activities.loading);
  const reportScheduleList = useAppSelector(state => state.reportSchedule.entities);
  const totalRecord = useAppSelector(state => state.activities.totalItems);
  const priorityLevelList = useAppSelector(state => state.common.priorityLevel);
  const workStatusActivitiesList = useAppSelector(state => state.common.workStatusActivities);
  const filters = useAppSelector(state => state.filters.activities);


  const [visibleConfirmDelete, setVisibleConfirmDelete] = useState(false);
  const [idDeletedActivities, setIdDeletedActivities] = useState(null);
  const [idSelected, setIdSelected] = useState(null);
  const [visibleFilter, setFilterModalVisible] = useState(false);
  const [visibleModalReport, setVisibleModalReport] = useState(false);
  const [visibleModalReportResult, setVisibleModalReportResult] = useState(false);

  const [isFormView, setFormView] = useState(false);
  const [searchText, setSearchText] = useState();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [checkedList, setCheckedList] = useState<string[]>(['action']);
  const [columnConfig, setColumnConfig] = useState<any[]>([]);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const employeeList = useAppSelector(state => state.common.orgsView);
  const [contextMenu, setContextMenu] = useState(null);
  const [isOpenModalFormActivities, setOpenModalFormActivities] = useState(false);
  const [isOpenModalConfirmCompleteHalfMonth, setOpenModalConfirmCompleteHalfMonth] = useState(false);
  const [isOpenModalConfirmCompleteMonth, setOpenModalConfirmCompleteMonth] = useState(false);
  const [isOpenModalConfirmComplete, setOpenModalConfirmComplete] = useState(false);
  const [isOpenModalConfirmCompleteQuarter, setOpenModalConfirmCompleteQuarter] = useState(false);
  const [planPeriodId, setPlanPeriodId] = useState(null);

  const actions = [
    {
      key: 1,
      label: 'Check in',
    },
    {
      key: 2,
      label: 'Xác nhận hoàn thành check in',
    },
  ];

  const dropDown = [
    {
      key: '1',
      label: 'Báo cáo kết quả thực hiện',
      onclick: item => handleUpdateReport(item),
      show: false, //isAdmin || activitiesPermissions.Add,
    },
    {
      key: '2',
      label: 'Danh sách kết quả thực hiện',
      onclick: item => handleViewReportResult(item),
      show: true, //isAdmin || krPermissions.UpdateWeight,
    },
  ];

  const newColumns = columnConfig.map(item => ({
    ...item,
    hidden: !checkedList.includes(item.key),
  }));

  useEffect(() => {
    if (employeeList && employeeList.length > 0 && !filters?.accountableId) {
      handleChangeEmployee(filters?.accountableId ?? employeeList[0].id)
    }
  }, [employeeList])



  useEffect(() => {
    setCheckedList(_.uniq([...checkedList, ...[...columns].map(x => {
      if (x.defaultShow) {
        return x.key
      }
    }
    )]));
    handleChangeRangeDate()
  }, []);

  useEffect(() => {
    setColumnConfig(createColumns());
  }, [checkedList]);

  useEffect(() => {
    getAllEntities();
  }, [paginationState.activePage, paginationState.itemsPerPage, paginationState.sort, filters]);

  useEffect(() => {
    dispatch(getAllReportSchedule());
    dispatch(getEmployees());
    dispatch(getSelectBoxWorkPriorityLevel())
    dispatch(getSelectBoxWorkStatusActivities())
  }, []);

  const createColumns = () => {
    const column = [];
    column.push({
      key: 'action',
      fixed: 'left',
      width: 80,
      filterDropdown: () => (
        <Checkbox.Group
          className="d-grid gap-3 p-3 overflow-auto height-350 align-items-center"
          value={checkedList}
          options={[...columns].map(x => {
            return {
              label: x.title,
              value: x.key,
            };
          })}
          onChange={handleAddColumnView}
        />
      ),
      filterIcon: () => <FilterFilled style={{ color: checkedList.length > 0 ? '#1890ff' : undefined }} />,
      render: (item: any) =>
        !item.activitiesId && (
          <div className="action">
            <span className="action-view">
              <Tooltip title="Xem">
                <FontAwesomeIcon
                  onClick={() => {
                    handleOpenModalFormActivities(item.activityId, true);
                  }}
                  icon="eye"
                />
              </Tooltip>
            </span>
            {item.editable &&
              <span className="action-edit">
                <Tooltip title="Sửa">
                  <FontAwesomeIcon
                    onClick={() => {
                      handleOpenModalFormActivities(item.activityId);
                    }}
                    icon="pencil-alt"
                  />
                </Tooltip>
              </span>}
            {item.deletable &&
              <span className="action-delete">
                <Tooltip title="Xóa">
                  <FontAwesomeIcon
                    onClick={() => {
                      handleWarningDeleteItem(item.activityId);
                    }}
                    icon="trash"
                  />
                </Tooltip>
              </span>
            }
          </div>
        ),
    });

    return [...column, ...columns];
  };

  const handleAddColumnView = values => {
    setCheckedList([...values, 'action']);
  };

  const onMenuClick = e => {
    const { key } = e;
    switch (parseInt(key, 10)) {
      case 1:
        navigate('check-in')
        break;
      case 2:
        handleTypeKrConfirmCompleteActivities();
        break;
      default:
        break;
    }
  };

  const handleTypeKrConfirmCompleteActivities = async () => {
    dispatch(setFilterOrgCheckIn(filters));
    const response = await dispatch(getCurrentCheckInType());
    if (response && response.payload) {
      const result = response.payload as { data: { checkinType: number, planPeriodId: string } };
      setPlanPeriodId(result.data.planPeriodId)
      switch (result.data.checkinType) {
        case 0:
          setOpenModalConfirmCompleteHalfMonth(true);
          break;
        case 1:
          setOpenModalConfirmCompleteMonth(true);
          break;
        case 2:
          setOpenModalConfirmComplete(true)
          break;
        case 3:
          setOpenModalConfirmCompleteQuarter(true)
          break;
        case 4:
          break;
        default:
          return;
      }
    }
  }

  const getAllEntities = (value?: string) => {
    if (filters?.accountableId) {
      const workPriorityLevel = filters?.workPriorityLevel !== "" && filters?.workPriorityLevel !== null ? filters.workPriorityLevel : undefined;
      const workStatus = filters?.workStatus !== "" && filters?.workStatus !== null ? filters.workStatus : undefined;
      dispatch(
        getEntities({
          searchText: value ?? searchText,
          page: paginationState.activePage,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
          pic: filters?.pic,
          accountableId: filters?.accountableId,
          dueDate: filters?.dueDate && filters.dueDate,
          field: filters?.field,
          alignId: filters?.alignId,
          reportScheduleId: filters?.reportScheduleId,
          projectId: filters?.projectId,
          workPriorityLevel,
          workStatus,
          startDate: filters?.startDate && filters.startDate,
          workTypeId: filters?.workTypeId,
        }),
      );
    }
  };

  const handleChange = (pageNumber: number, size: number, sorter: any) => {
    const { order, sort } = paginationState;
    setPaginationState({
      ...paginationState,
      order: Object.keys(sorter).length !== 0 ? (sorter.order && OrderByType[sorter.order] === OrderByType.descend ? DESC : ASC) : order,
      sort: Object.keys(sorter).length !== 0 ? sorter.columnKey : sort,
      activePage: pageNumber,
      itemsPerPage: size,
    });
  };

  const handleFreeTextSearchQuery = query => {
    setSearchText(query);
    getAllEntities(query);
  };

  const handleWarningDeleteItem = (id: number) => {
    setVisibleConfirmDelete(true);
    setIdDeletedActivities(id);
  };

  const handleConfirmDelete = () => {
    if (idDeletedActivities) {
      dispatch(deleteEntity(idDeletedActivities))
        .then(() => {
          setExpandedRowKeys([]);
          getAllEntities();
        })
        .finally(() => {
          setVisibleConfirmDelete(false);
        });
    }
  };


  const getAllRowKeys = item => {
    return item.reduce((keys, value) => {
      keys.push(value.code);

      if (value.keyResults) {
        keys = keys.concat(getAllRowKeys(value.keyResults));
      }

      return keys;
    }, []);
  };

  const handleUpdateReport = item => {
    setIdSelected(item.activityId);
    setVisibleModalReport(true);
  };

  const handleCloseModalReportActivities = () => {
    setIdSelected(null);
    setVisibleModalReport(false);
  };

  const handleViewReportResult = item => {
    setIdSelected(item.activityId);
    setVisibleModalReportResult(true);
  };

  const handleCloseModalReportActivitiesResult = () => {
    setIdSelected(null);
    setVisibleModalReportResult(false);
  };

  const handleOpenModalFormActivities = (id?: string, isDisabled = false) => {
    setIdSelected(id);
    setOpenModalFormActivities(true);
    setFormView(isDisabled)
  };

  const handleCloseModalFormActivities = (isReload = false) => {
    setIdSelected(null);
    setOpenModalFormActivities(false);
    if (isReload) {
      getAllEntities();
    }
  };

  const handleRightClick = (event, record, rowIndex) => {
    event.preventDefault();
    const { clientX, clientY } = event;
    setContextMenu(
      <Menu>
        {dropDown
          .map(item =>
            item.show && <Menu.Item key={item.key} onClick={() => { item.onclick(record) }}>{item.label}</Menu.Item>
          )}
      </Menu>
    );
    setMenuPosition({ x: clientX, y: clientY });
  };

  const handleChangeEmployee = (value: string) => {
    const employee = _.find(employeeList, o => o.id === value);
    dispatch(
      setFilterActivities({
        ...filters,
        accountableId: value,
        accountableName: employee?.name,
      }),
    );
  };

  const handleChangeReportSchedule = (value: string) => {
    dispatch(
      setFilterActivities({
        ...filters,
        reportScheduleId: value,
      }),
    );
  };

  const handleChangeActivitiesStatus = (value: string) => {
    dispatch(
      setFilterActivities({
        ...filters,
        workStatus: value,
      }),
    );
  };

  const handleChangePriority = (value: string) => {
    dispatch(
      setFilterActivities({
        ...filters,
        workPriorityLevel: value,
      }),
    );
  };

  const handleChangeRangeDate = (dateRanges = [dayjs(), dayjs().endOf('month')]) => {
    const fromDate = dateRanges[0] && dateRanges[0].format(APP_LOCAL_DATE_FORMAT_PAYLOAD);
    const toDate = dateRanges[1] && dateRanges[1].format(APP_LOCAL_DATE_FORMAT_PAYLOAD);
    dispatch(
      setFilterActivities({
        ...filters,
        startDate: fromDate,
        dueDate: toDate,
      }),
    );
  }

  const handleExport = () => {
    const payload = {
      accountableId: filters?.accountableId,
      startDate: filters?.startDate,
      dueDate: filters?.dueDate,
    }
    dispatch(
      exportExcel(payload)).then(res => {
        if (res.payload) {
          const resultExcel = res.payload as any;
          saveAs(
            new Blob([resultExcel.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
            `Báo cáo_${dayjs().format('DDMMYYYYhhmmss')}`,
          );
        }
      });
  }

  return (
    <Container className="view">
      <div className="d-flex gap-5 mt-2">
        <Row className="d-flex justify-content-between w-100">
          <Col md={20}>
            <Row>
              <Col md={16}>
                <Title level={3}>{`Danh sách công việc ${filters?.accountableName ? `- ${filters?.accountableName}` : ''}`}</Title>
              </Col>
              <Col md={1} />
              <Col md={6}>
                <Dropdown
                  className="green"
                  trigger={['click']}
                  menu={{ items: actions, onClick: onMenuClick }}
                  placement="bottomCenter"
                >
                  <Button size="large">
                    <DownOutlined /> Check in
                  </Button>
                </Dropdown>
              </Col>
            </Row>
          </Col>
          <Col md={4}>
            <Select
              className="w-100"
              filterOption={filterOption}
              onChange={handleChangeEmployee}
              value={filters?.accountableId}
              showSearch
              size="large"
              options={employeeList.map(x => {
                return {
                  label: x.name,
                  value: x.id,
                };
              })}
            />

          </Col>
        </Row>
      </div>

      <div className="table">
        <div className="header">
          <Col md={19}>
            <Row className='w-100 d-flex gap-2'>
              <Col md={4}>
                <Select
                  className="w-100"
                  defaultValue={null}
                  value={filters?.workStatus}
                  options={[{ label: "Tình trạng CV: tất cả", value: null }, ...workStatusActivitiesList]}
                  onChange={handleChangeActivitiesStatus}
                  filterOption={filterOption}
                  placeholder="Chọn tình trạng cv"
                  size="large"
                />
              </Col>
              <Col md={4}>
                <Select
                  className="w-100"
                  value={filters?.workPriorityLevel}
                  defaultValue={null}
                  onChange={handleChangePriority}
                  options={[{ label: "Mức độ ưu tiên: tất cả", value: null }, ...priorityLevelList]}
                  filterOption={filterOption}
                  placeholder="Chọn mức độ ưu tiên"
                  size="large"
                />
              </Col>
              <Col md={4}>
                <Select
                  className="w-100"
                  value={filters?.reportScheduleId}
                  showSearch
                  options={reportScheduleList.map(x => {
                    return {
                      value: x.id,
                      label: x.name,
                    };
                  })}
                  onChange={handleChangeReportSchedule}
                  filterOption={filterOption}
                  placeholder="Chọn kỳ báo cáo"
                  size="large"
                />
              </Col>
              <Col md={6}>
                <Search size="large" className='w-100' allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
              </Col>
              <Col md={1}>
                <Button
                  className={`filter primary ${(filters?.alignId ||
                    filters?.fieldValue ||
                    filters?.projectId ||
                    filters?.workStatus ||
                    filters?.workTypeId ||
                    filters?.fromDate ||
                    filters?.toDate) ? 'active-filter' : ''}`}
                  size="large"
                  onClick={() => {
                    setFilterModalVisible(true);
                  }}
                  icon={<ReactSVG src={'content/images/icons/filter.svg'} />}
                />
              </Col>
            </Row>
          </Col>
          <Col md={5}>
            <Row className='w-100 justify-content-end'>
              <Col>
                <Button disabled className="primary" size="large" onClick={() => { handleExport() }}>
                  Xuất File Excel
                </Button>
                {/* <Dropdown className="primary" trigger={['click']} menu={{ items: actionsExportExcel, onClick: onClickExportReport }} placement="bottomCenter">
                  <Button size="large">
                    <DownOutlined /> Xuất File Excel
                  </Button>
                </Dropdown> */}
              </Col>
              <Col md={1} />
              <Col>
                <Button
                  size="large"
                  onClick={() => {
                    handleOpenModalFormActivities();
                  }}
                  className="primary"
                  icon={<PlusOutlined />}
                >
                  Thêm công việc
                </Button>
              </Col>
            </Row>
          </Col>
        </div>
      </div>
      <TableComponent
        data={activitiesList.map((x, index) => {
          return {
            key: index + 1,
            ...x,
          };
        })}
        scroll={true}
        total={totalRecord}
        isFetching={isLoading}
        columns={newColumns}
        tableLayout="fixed"
        handleRightClick={(event, record, index) => { handleRightClick(event, record, index) }}
        expandedRowKeys={expandedRowKeys}
        setExpandedRowKeys={setExpandedRowKeys}
        handlePageChange={(pageNumber: number, size: number, search: any, sorter: any) => {
          handleChange(pageNumber, size, sorter);
        }}
      />
      {contextMenu && (
        <Dropdown
          overlay={contextMenu}
          open
          trigger={['contextMenu']}
          placement="bottomLeft"
          onOpenChange={(flag) => !flag && setContextMenu(null)}
          overlayStyle={{
            position: 'fixed',
            top: menuPosition.y,
            left: menuPosition.x,
            zIndex: 1000,
          }}
        >
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100vh' }} />
        </Dropdown>
      )}
      {visibleModalReportResult && (
        <ReportActivitiesResult
          isOpen={visibleModalReportResult}
          idSelected={idSelected}
          onClose={handleCloseModalReportActivitiesResult}
        />
      )}
      {visibleModalReport && (
        <ReportActivities isOpen={visibleModalReport} idSelected={idSelected} onClose={handleCloseModalReportActivities} />
      )}
      {isOpenModalFormActivities && (
        <ActivitiesUpdate isOpen={isOpenModalFormActivities} isView={isFormView} id={idSelected} onClose={handleCloseModalFormActivities} />
      )}
      {visibleFilter && (
        <FilterModal visible={visibleFilter} onCancel={() => setFilterModalVisible(false)} />
      )}
      {isOpenModalConfirmComplete &&
        <ConfirmComplete
          planPeriodId={planPeriodId}
          isOpen={isOpenModalConfirmComplete}
          onClose={() => {
            setOpenModalConfirmComplete(false);
          }}
        />
      }
      {isOpenModalConfirmCompleteQuarter &&
        <ConfirmCompleteQuarter
          isOpen={isOpenModalConfirmCompleteQuarter}
          onClose={() => {
            setOpenModalConfirmCompleteQuarter(false);
          }}
        />
      }
      {isOpenModalConfirmCompleteHalfMonth &&
        <ConfirmCompleteHalfMonth
          isOpen={isOpenModalConfirmCompleteHalfMonth}
          onClose={() => {
            setOpenModalConfirmCompleteHalfMonth(false);
          }}
        />
      }
      {isOpenModalConfirmCompleteMonth &&
        <ConfirmCompleteMonth
          isOpen={isOpenModalConfirmCompleteMonth}
          onClose={() => {
            setOpenModalConfirmCompleteMonth(false);
          }}
        />
      }
      <ModalConfirmComponent
        visible={visibleConfirmDelete}
        onCancel={() => {
          setVisibleConfirmDelete(false);
        }}
        onConfirm={handleConfirmDelete}
        title={`Bạn có muốn xóa công việc`}
      />
    </Container>
  );
};

export default Activities;
